import { Grid } from "@mui/material";
import React from "react";
import LoadDocumentCmp from "../thumbnail/loadDocumentCmp";
import SlideDocument from "../thumbnail/slideDocument";
import LoadDocument from "../thumbnail/loadDocument";
import UnionLoadDocument from "../thumbnail/unionLoadDocument";

const DocumentInfoComponentSingle = (props: any) => {
  let accumulative = false;
  if (
    props.accumulative?.isAccumulative == true &&
    props.accumulative?.accumulativeAmount == props.accumulative?.inquiryAmount
  ) {
    accumulative = true;
  } else {
    accumulative = false;
  }
  return (
    <>
      <div
        className="row "
        style={{
          marginRight: props.marginRight ? props.marginRight : "2vh",
          marginLeft: props.marginLeft ? props.marginLeft : "-6vh",
        }}
      >
        {/* <SlideDocument data={props.data} /> */}
        {accumulative ? (
          <UnionLoadDocument
            data={props?.data}
            accumulative={props?.accumulative!}
          />
        ) : props?.data[0]?.documentType == "InstallmentCheque" ||
          props?.data.length > 0 ? (
          <SlideDocument data={props.data} />
        ) : (
          <LoadDocument data={props.data} />
        )}
      </div>
    </>
  );
};

export default DocumentInfoComponentSingle;
